if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.variantIdInput = this.form.querySelector('[name="id"]');

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.quantityBreaks = document.getElementById(
          `quantity-breaks-${this.dataset.sectionId}`
        );

        this.customFields = document.querySelectorAll(
          `[id^='CustomField-${this.dataset.sectionId}-']`
        );

        this.variantInputs = this.form.querySelector('.product-form__variants');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      /* ------------------------------------------------------------
        REQUIRED BY product-info.js (DO NOT REMOVE)
      ------------------------------------------------------------ */
      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings?.addToCart ||
              this.submitButtonText.textContent;
          }
        }
      }

      /* ------------------------------------------------------------ */

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Prevent double submit
        if (this.submitButton.classList.contains('loading')) return;

        this.handleErrorMessage(false);

        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        let hasVariants = false;

        // Quantity breaks support
        if (
          this.quantityBreaks &&
          this.variantInputs &&
          this.quantityBreaks.formVariants?.length
        ) {
          hasVariants = true;
          let html = '';

          this.quantityBreaks.formVariants.forEach((variant, i) => {
            html += `
              <input type="hidden" name="items[${i}][id]" value="${variant.id}">
              <input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">
            `;

            this.customFields.forEach((field) => {
              html += `
                <input type="hidden"
                  name="items[${i}][properties][${field.fieldName}]"
                  value="${field.value}">
              `;
            });
          });

          this.variantInputs.innerHTML = html;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (hasVariants) {
          ['id', 'quantity'].forEach((key) => formData.delete(key));
        }

        fetch(routes.cart_add_url, {
          ...config,
          body: formData,
        })
          .then((res) => res.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => this.cart.renderContents(response));
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch(console.error)
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(message = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        const errorMessageElement =
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !message);

        if (message) {
          errorMessageElement.textContent = message;
        }
      }
    }
  );
}
